/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { FormValueModel, NormalizeFormValuesForDatabaseService } from '@domain/dynamic-form';
import { ColumnModel, DataModel, PrimaryKeyValueModel } from '@shared';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { QueryParamsProvider } from '@domain/routing';
import { TableTypeProvider } from '../../../domain/business-layer/services/table-type.provider';
import { BusinessLayerService } from '../../../domain/business-layer/services/business-layer.service';
import { ColumnRepository, DataRepository } from '@database/workspace';
import { FormNormalizerBuilder } from './form-normalizer.builder';

@Injectable()
export class NormalizeFormValueService {
	public constructor(
		private columnRepository: ColumnRepository,
		private tableTypeProvider: TableTypeProvider,
		private queryParamsProvider: QueryParamsProvider,
		private businessLayerService: BusinessLayerService,
		private dataRepo: DataRepository,
		private normalizeFormValuesForDatabaseService: NormalizeFormValuesForDatabaseService
	) {}

	public prepareFormValue$(table: string, formValue: FormValueModel): Observable<FormValueModel> {
		const workfileId = this.queryParamsProvider.workfileId;
		const projectNumber = this.queryParamsProvider.projectNumber;
		const entityName = this.queryParamsProvider.parentTableName;
		const parentEntryId = Number(this.queryParamsProvider.entryId);
		const activeTableId = Number(this.queryParamsProvider.activeTableId);

		return this.tableTypeProvider.getTableType$(table, workfileId).pipe(
			switchMap((tableTypes: string[]) =>
				this.dataRepo.getTableEntry$(table, projectNumber, activeTableId).pipe(
					switchMap((row: DataModel) =>
						this.businessLayerService
							.getPrimaryKeyAndValue$(workfileId, projectNumber, entityName, parentEntryId)
							.pipe(
								switchMap((primaryKeyValue: PrimaryKeyValueModel[]) =>
									this.columnRepository.getColumns$(table).pipe(
										map((dataColumns: ColumnModel[]) => {
											const builder = new FormNormalizerBuilder(
												formValue,
												this.queryParamsProvider,
												this.normalizeFormValuesForDatabaseService
											);
											builder.setPropertiesBasedOnDataType(dataColumns);
											builder.setBaseProperties(projectNumber);
											builder.toStringSampleAndStadardProperties();
											builder.setSampleParentLink(
												tableTypes,
												row,
												this.queryParamsProvider.formActionType()
											);
											builder.setPrimaryKey(tableTypes, primaryKeyValue);

											return builder.build();
										})
									)
								)
							)
					)
				)
			)
		);
	}
}
